<template>
  <!-- Climbing Wall section start -->
  <section id="climbing-wall" class="px-12 lg:px-32 py-16 relative max-width-container">
    <!-- Main text and image container start -->
    <div class="flex flex-col lg:flex-row lg:items-stretch lg:space-x-8">
      <!-- Main text start -->
      <div class="lg:w-1/2">
        <h1 class="uppercase text-3xl mb-4 font-semibold">Mobil Mászófal</h1>
        <div class="text-stone-500 mb-8 text-justify">
          <p>
            Rendezvényét igazán különlegessé teheti a mobil fal, amely nemcsak
            <strong>szórakozást és kihívást</strong> kínál minden korosztálynak, hanem
            egyúttal kiváló <strong>testmozgás</strong> is. A
            <strong>8 méter magas mobil mászófal</strong> egyedülálló élményt nyújt,
            miközben fejleszti a <strong>kitartást</strong>, az
            <strong>egyensúlyérzéket</strong> és a
            <strong>problémamegoldó képességet</strong>. A mászófal fogásai különböző
            nehézségi szinteket biztosítanak, így kezdők, haladók és tapasztalt mászók
            számára is ideális választás. Ez a fejlesztő eszköz nemcsak a fizikai, hanem a
            mentális képességeket is erősíti.
          </p>

          <p class="mt-4">
            A <strong>mobil mászófal bérlés</strong> tökéletes választás céges
            eseményekre, fesztiválokra, iskolai rendezvényekre és sportnapokra. A mászófal
            nemcsak izgalmas programot kínál, hanem maradandó élményt is nyújt a
            résztvevők számára, miközben elősegíti a csapatmunkát és az együttműködést. A
            <strong>mászófal bérlés</strong> lehetőséget ad arra, hogy a résztvevők
            kipróbálják magukat egy biztonságos, mégis kihívásokkal teli környezetben.
            Fedezze fel a <strong>mobil mászófal árak</strong> kedvező lehetőségeit, és
            tegye felejthetetlenné rendezvényét egy olyan programmal, amely egyszerre
            szórakoztató, fejlesztő és egészséges!
          </p>
        </div>
      </div>
      <!-- Main text end -->

      <!-- Image container start -->
      <div class="lg:w-1/2">
        <!-- Mobil nézet: <img> -->
        <img v-if="isMobile" :src="climbingWallImage01"
          alt="Mozgásban Maradók Egyesülete mobil mászófal és ügyességi játékok"
          class="w-full h-auto rounded-lg shadow-lg" />
        <!-- Asztali nézet: background-image -->
        <div v-else class="bg-cover bg-center rounded-lg shadow-lg h-full"
          :style="{ backgroundImage: `url(${climbingWallImage01})` }"></div>
      </div>
      <!-- Image container end -->
    </div>

    <!-- Checkmark list and image container start -->
    <div class="flex flex-col lg:flex-row-reverse lg:items-stretch lg:space-x-8 lg:space-x-reverse mt-4 lg:mt-16">
      <!-- Checkmark list start -->
      <div class="lg:w-1/2">
        <ul class="space-y-4 text-stone-500">
          <!-- Group 1: Általános jellemzők -->
          <li>
            <div class="flex items-start mb-2">
              <i class="fas fa-mountain w-6 mt-1 mr-2"></i>
              <span class="font-semibold">Általános jellemzők</span>
            </div>
            <ul class="space-y-2 pl-8">
              <li class="flex items-start">
                <i class="fas fa-check-circle w-6 text-green-500 mt-1 mr-2"></i>
                <span>8 méter magas, háromoldalú mobil fal</span>
              </li>
              <li class="flex items-start">
                <i class="fas fa-check-circle w-6 text-green-500 mt-1 mr-2"></i>
                <span>Egyszerre 3 résztvevő számára</span>
              </li>
              <li class="flex items-start">
                <i class="fas fa-check-circle w-6 text-green-500 mt-1 mr-2"></i>
                <span>Különböző nehézségi szintű mászófal fogások és utak</span>
              </li>
              <li class="flex items-start">
                <i class="fas fa-check-circle w-6 text-green-500 mt-1 mr-2"></i>
                <span>Bármilyen sík területre telepíthető</span>
              </li>
            </ul>
          </li>

          <!-- Group 2: Biztonság -->
          <li>
            <div class="flex items-start mb-2">
              <i class="fas fa-shield-alt w-6 mt-1 mr-2"></i>
              <span class="font-semibold">Biztonság</span>
            </div>
            <ul class="space-y-2 pl-8">
              <li class="flex items-start">
                <i class="fas fa-check-circle w-6 text-green-500 mt-1 mr-2"></i>
                <span>TÜV tanúsítvánnyal és statikai megfeleléssel</span>
              </li>
              <li class="flex items-start">
                <i class="fas fa-check-circle w-6 text-green-500 mt-1 mr-2"></i>
                <span>Profi biztosító személyzet a helyszínen</span>
              </li>
              <li class="flex items-start">
                <i class="fas fa-check-circle w-6 text-green-500 mt-1 mr-2"></i>
                <span>Szikla- és hegymászók által tesztelt rendszer</span>
              </li>
              <li class="flex items-start">
                <i class="fas fa-check-circle w-6 text-green-500 mt-1 mr-2"></i>
                <span>Felsőbiztosítás a maximális biztonság érdekében</span>
              </li>
            </ul>
          </li>

          <!-- Group 3: Rendezvények -->
          <li>
            <div class="flex items-start mb-2">
              <i class="fas fa-calendar-alt w-6 mt-1 mr-2"></i>
              <span class="font-semibold">Rendezvények</span>
            </div>
            <ul class="space-y-2 pl-8">
              <li class="flex items-start">
                <i class="fas fa-check-circle w-6 text-green-500 mt-1 mr-2"></i>
                <span>Ideális céges rendezvényekre, fesztiválokra, sportnapokra</span>
              </li>
              <li class="flex items-start">
                <i class="fas fa-check-circle w-6 text-green-500 mt-1 mr-2"></i>
                <span>Iskolákba, csapatépítőkre és városnapokra is tökéletes</span>
              </li>
              <li class="flex items-start">
                <i class="fas fa-check-circle w-6 text-green-500 mt-1 mr-2"></i>
                <span>Éjszakai eseményekhez világítással is elérhető</span>
              </li>
              <li class="flex items-start">
                <i class="fas fa-check-circle w-6 text-green-500 mt-1 mr-2"></i>
                <span>Garantáltan emlékezetes élmény minden résztvevőnek</span>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <!-- Checkmark list end -->

      <!-- Image container start -->
      <div class="lg:w-1/2 bg-cover bg-center rounded-lg shadow-lg mt-16 lg:mt-0"> <!-- Mobil nézet: <img> -->
        <img v-if="isMobile" :src="climbingWallImage02"
          alt="Mozgásban Maradók Egyesülete mobil mászófal és ügyességi játékok"
          class="w-full h-auto rounded-lg shadow-lg" />
        <!-- Asztali nézet: background-image -->
        <div v-else class="bg-cover bg-center rounded-lg shadow-lg h-full"
          :style="{ backgroundImage: `url(${climbingWallImage02})` }"></div>
      </div>
      <!-- Image container end -->

    </div>
    <!-- Checkmark list and image container end -->

    <!-- FAQ section start -->
    <div class="mt-16">
      <h2 class="uppercase text-2xl mb-6 font-semibold flex items-center">
        <i class="fas fa-question-circle text-green-500 mr-2"></i>
        Gyakran ismételt kérdések
      </h2>
      <div class="space-y-4">
        <div v-for="(faq, index) in faqs" :key="index" :class="[
          'p-4 rounded-lg shadow-md cursor-pointer',
          activeFaq === index ? 'bg-green-30' : 'bg-stone-100'
        ]" @click="toggleFaq(index)">
          <h3 class="font-semibold text-lg flex items-center">
            <i :class="faq.icon + ' text-green-500 mr-2'"></i> {{ faq.question }}
          </h3>
          <p v-if="activeFaq === index" class="text-stone-500 mt-2">
            {{ faq.answer }}
          </p>
        </div>
      </div>
    </div>
    <!-- FAQ section end -->
  </section>
  <!-- Climbing Wall section end -->
</template>

<script>
export default {
  data() {
    return {
      climbingWallImage01: require("@/assets/images/climbing-wall/climbing-wall-01.webp"),
      climbingWallImage02: require("@/assets/images/climbing-wall/climbing-wall-02.webp"),
      isMobile: false, // Mobil nézet ellenőrzése
      faqs: [
        {
          question: "Kik használhatják a mobil mászófalat?",
          answer: "A mobil mászófal minden korosztály számára elérhető, 3 éves kortól.",
          icon: "fas fa-user",
        },
        {
          question: "Milyen eseményekre ajánljuk?",
          answer:
            "Ideális városnapokra, céges csapatépítőkre, iskolai rendezvényekre és fesztiválokra.",
          icon: "fas fa-calendar-alt",
        },
        {
          question: "Mennyi idő alatt állítható fel a mászófal?",
          answer: "A mobil mászófal felállítása körülbelül 2 órát vesz igénybe.",
          icon: "fas fa-clock",
        },
        {
          question: "Milyen biztonsági intézkedések vannak?",
          answer:
            "TÜV tanúsítvánnyal rendelkezünk, és profi biztosító személyzet gondoskodik a biztonságról.",
          icon: "fas fa-shield-alt",
        },
        {
          question: "Hogyan foglalhatom le a mobil mászófalat?",
          answer:
            "Vegye fel velünk a kapcsolatot a weboldalunkon található ajánlatkérő űrlapon keresztül, emailben: info@mozgasbanmaradok.hu, vagy telefonon: +36 30 279 7768.",
          icon: "fas fa-phone",
        },
        {
          question: "Mekkora terület szükséges a mászófal felállításához?",
          answer:
            "A mobil mászófal felállításához körülbelül 10x10 méteres sík terület szükséges.",
          icon: "fas fa-map-marker-alt",
        },
        {
          question: "Milyen időjárási körülmények között használható?",
          answer:
            "A mászófal enyhe esőben is használható, de erős szél vagy vihar esetén nem üzemeltethető.",
          icon: "fas fa-cloud-sun",
        },
        {
          question: "Milyen felszerelést biztosítanak a mászáshoz?",
          answer:
            "Minősített beülőket, biztonsági hevedereket, profi biztosító eszközöket biztosítunk minden résztvevő számára.",
          icon: "fas fa-tools",
        },
        {
          question: "Van-e lehetőség éjszakai mászásra?",
          answer:
            "Igen, a mobil mászófalat megfelelő világítással is tudjuk biztosítani éjszakai eseményekhez.",
          icon: "fas fa-moon",
        },
        {
          question: "Mennyi időre lehet kibérelni a mászófalat?",
          answer:
            "A bérlési idő rugalmas, akár néhány órára, akár egész napra is elérhető a szolgáltatás.",
          icon: "fas fa-hourglass-half",
        },
      ],
      activeFaq: null,
    };
  },
  mounted() {
    this.checkViewport();
    window.addEventListener("resize", this.checkViewport);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkViewport);
  },
  methods: {
    toggleFaq(index) {
      this.activeFaq = this.activeFaq === index ? null : index;
    },
    checkViewport() {
      this.isMobile = window.innerWidth < 768; // Mobil nézet ellenőrzése
    },
  },
};
</script>

<style>
.bg-green-10 {
  background-color: rgba(212, 230, 166, 0.1);

  /* Világos zöld 10% átlátszóság */
}

.bg-cover {
  background-size: cover;
}

.bg-center {
  background-position: center;
}
</style>